module.exports = __webpack_public_path__ + "hero-what-we-do.a_ffB0Ne.png";